import PropTypes from 'prop-types';
import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import events from 'lib/events';
import {FormattedMessage} from 'react-intl';

class EditableDatePicker extends React.Component {
  static propTypes = {
    dataKey: PropTypes.string.isRequired,
    dateFormat: PropTypes.string,
    editMode: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    style: PropTypes.object,
    group: PropTypes.object,
    value: PropTypes.object,
    validate: PropTypes.func,
    validateMessage: PropTypes.string,
    didValidate: PropTypes.func,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    popperPlacement: PropTypes.string,
    required: PropTypes.bool,
    'data-event-action': PropTypes.string,
    'data-event-category': PropTypes.string,
  };

  state = {
    isValid: true,
    selectedDate: null,
  };

  componentDidMount() {
    if (this.props.group) {
      this.props.group.addComponent(this);
    }

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value && !this.state.isValid) {
      this.validate(nextProps.value);
    }

  }

  componentWillUnmount() {
    if (this.props.group) {
      this.props.group.removeComponent(this);
    }
  }

  validate = (val = this.props.value) => {

    if (this.props.required && !val) {
      this.setState({
        isValid: false,
      });
      return false;
    }

    //If there is a value must be a valid date
    if (!moment(val, this.props.dateFormat, true).isValid() && val) {
      this.setState({
        isValid: false,
      });
      return false;
    }

    if (!this.props.validate) {
      this.setState({
        isValid: true,
      });
      return true;
    }

    let validateResult = this.props.validate(val);

    if (validateResult === false) {
      this.setState({
        isValid: false,
      });

      if (val && this.props.validateMessage) {
        events.publish('error.user', {
          message: this.props.validateMessage,
          key: this.props.dataKey,
        });
      }
      return false;
    }

    this.setState({isValid: true});
    events.publish('cancel.error', {key: this.props.dataKey});

    if (this.props.didValidate) {
      this.props.didValidate(this.props.dataKey, validateResult);
    }

    return true;
  };


  handleChange = (e) => {
    if (this.props.onChange) {
      let newVal = moment(e, this.props.dateFormat, true);

      if (newVal.isValid()) {
        this.props.onChange({key: this.props.dataKey, value: newVal});
      }

      if (!this.state.isValid) {
        this.validate(newVal);
      }
    }
  };

  onBlur = (e) =>{
    const dateString = e.target.value;
    let newVal = moment(dateString, this.props.dateFormat, true).isValid() ? moment(dateString, this.props.dateFormat, true) : dateString;

    this.props.onChange({key: this.props.dataKey, value: newVal});

    if (!this.state.isValid || newVal !== this.props.value) {
      this.validate(newVal);
    }

  };

  focus = () => {
    if (this.datePicker) {
      this.datePicker.input.focus();
      this.datePicker.input.scrollIntoView(false);
    }
  };

  render() {
    let content;
    let displayDate = this.props.value && moment(this.props.value, this.props.dateFormat, true).isValid() ?
      moment(this.props.value, this.props.dateFormat, true) :
      moment();
    let displayText = this.props.value  && moment(this.props.value, this.props.dateFormat, true).isValid() ?
      moment(this.props.value, this.props.dateFormat, true).format(this.props.dateFormat) :
      <FormattedMessage id='general.none' />;

    if (this.props.editMode) {
      content =
        <DatePicker selected={displayDate}
          ref={(r) => { this.datePicker = r; }}
          dateFormat={this.props.dateFormat}
          dateFormatCalendar={this.props.dateFormat}
          onChange={this.handleChange}
          onBlur={this.onBlur}
          className={this.state.isValid ? '' : 'error'}
          minDate={this.props.minDate}
          maxDate={this.props.maxDate}
          popperPlacement={this.props.popperPlacement}
          data-event-category={this.props['data-event-category']}
          data-event-action={this.props['data-event-action']} />
      ;
    } else {
      content = displayText;
    }

    let wrapperClass = 'editable-datepicker';

    if (!this.props.editMode) {
      wrapperClass += ' form-control-static';
    }

    return (
      <div className={wrapperClass} style={this.props.style ? this.props.style : null}>
        {content}
      </div>
    );
  }
}

export default EditableDatePicker;
